import { popularKeywords } from "@/mocks/manhwaData";

interface HeroProps {
  query: string;
  onQueryChange: (value: string) => void;
  onSearch: () => void;
}

export default function Hero({ query, onQueryChange, onSearch }: HeroProps) {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch();
  };

  return (
    <section id="top" className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden md:min-h-[640px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20manhwa%20illustration%20banner%20with%20energetic%20young%20characters%20jumping%20out%20of%20comic%20panels%2C%20bold%20coral%20red%20and%20warm%20amber%20and%20teal%20palette%2C%20dynamic%20speed%20lines%2C%20playful%20vibrant%20youthful%20comic%20art%2C%20no%20text&width=1600&height=900&seq=hero-manhwa&orientation=landscape"
          alt="漫画韩漫网址导航首页背景图"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/80"></div>

      <div className="relative z-10 flex w-full flex-col items-center px-4 py-20 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs text-background-50 ring-1 ring-background-50/30 backdrop-blur">
          <i className="ri-fire-fill text-accent-400"></i>
          聚合热门韩漫站点 · 一个页面收齐
        </span>

        <h1 className="mt-6 font-heading text-3xl leading-tight text-background-50 sm:text-4xl md:text-5xl">
          漫画韩漫网址大全
        </h1>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          收藏本站，随时找到漫画韩漫网址导航入口与最新发布页，无需反复搜索，直接进入阅读页，追更更方便。
        </p>

        <form
          onSubmit={handleSubmit}
          className="mt-8 flex w-full max-w-2xl flex-col gap-2 sm:flex-row sm:items-center sm:rounded-full sm:bg-background-50 sm:p-1.5"
        >
          <div className="flex flex-1 items-center gap-2 rounded-full bg-background-50 px-4 py-3 sm:rounded-full sm:bg-transparent sm:px-4 sm:py-2">
            <i className="ri-search-line text-lg text-foreground-500"></i>
            <input
              type="text"
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              placeholder="搜索想看的韩漫题材，如：恋爱、奇幻…"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始搜索
          </button>
        </form>

        <div className="mt-6 flex max-w-3xl flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-background-100/70">热门关键词：</span>
          {popularKeywords.map((kw) => (
            <button
              key={kw}
              type="button"
              onClick={() => {
                onQueryChange(kw);
                onSearch();
              }}
              className="whitespace-nowrap rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-100 transition-colors hover:bg-accent-500 hover:text-foreground-950"
            >
              {kw}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}